module.exports = __webpack_public_path__ + "/login_ui/img/bq-0bd5780a60eb6f6d1d8a507c11b7b84a.svg";